import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { getMeGroups } from "../redux/apiCalls/data/dataCall";

const capitalizeFirstLetter = (string) => {
  if (!string) return "";
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

export const useMeasurementGroups = (
  dispatch,
  accessToken,
  { onlyConfort = false } = {}
) => {
  const [allGroups, setAllGroups] = useState({
    allPrimary: [],
    allSecondary: [],
  });

  const [primary, setPrimary] = useState(() => {
    try {
      const saved = localStorage.getItem("consumption_state");
      if (saved) {
        const parsed = JSON.parse(saved);
        return parsed.primary || "";
      }
      return "";
    } catch (e) {
      return "";
    }
  });

  const [second, setSecond] = useState(() => {
    try {
      const saved = localStorage.getItem("consumption_state");
      if (saved) {
        const parsed = JSON.parse(saved);
        return parsed.secondary || "";
      }
      return "";
    } catch (e) {
      return "";
    }
  });

  const measurementGroups = useSelector(
    (state) => state.data.measurementGroups
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (accessToken && !measurementGroups) {
          await getMeGroups(dispatch, accessToken);
        }
      } catch (error) {
        console.error("Error fetching measurement groups:", error);
      }
    };
    fetchData();
  }, [dispatch, accessToken, measurementGroups]);

  useEffect(() => {
    if (measurementGroups && Array.isArray(measurementGroups)) {
      if (onlyConfort) {
        const primaryGroups = ["Confort"];
        const secondaryGroups =
          primary === "Confort"
            ? [
                ...new Set(
                  measurementGroups
                    .filter(
                      (item) =>
                        capitalizeFirstLetter(item.groupM) === "Confort" &&
                        ["Humidity", "Temperature"].includes(item.sub_group)
                    )
                    .map((item) => item.sub_group)
                ),
              ]
            : [];
        setAllGroups({
          allPrimary: primaryGroups,
          allSecondary: secondaryGroups,
        });
      } else {
        const primaryGroups = [
          ...new Set(
            measurementGroups.map((item) => capitalizeFirstLetter(item.groupM))
          ),
        ];
        const secondaryGroups = primary
          ? [
              ...new Set(
                measurementGroups
                  .filter(
                    (item) => capitalizeFirstLetter(item.groupM) === primary
                  )
                  .map((item) => item.sub_group)
              ),
            ]
          : [];
        setAllGroups({
          allPrimary: primaryGroups,
          allSecondary: secondaryGroups,
        });
      }
    }
  }, [measurementGroups, primary, onlyConfort]);

  const isFirstPrimaryRef = useRef(true);
  useEffect(() => {
    if (isFirstPrimaryRef.current) {
      isFirstPrimaryRef.current = false;
      return;
    }
    setSecond("");
  }, [primary]);

  return {
    allGroups,
    primary,
    setPrimary,
    second,
    setSecond,
  };
};
